import axios from 'axios'
import config from '../config'

const Permission = {
    state: {
        permissionList: [],
        error: false,
        msg: ''
    },
    mutations: {
        PermissionList: (state, permissionList) => state.permissionList = permissionList,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {

        async fetchPermissionList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_PERMISSION_LIST,
                data: data
            })
            .then((result) => {
                commit('PermissionList', result.data.permission)
            }).catch((err) => {
                console.log(err);
            });
        },
        async addPermission({commit}, data){
            await axios({
                method:'post',
                url: config.ADD_PERMISSION,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async updatePermission({commit},data){
            await axios({
                method:'post',
                url: config.UPDATE_PERMISSION,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async deletePermission({commit}, data){
            await axios({
                method:'delete',
                url: config.DELETE_PERMISSION,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        }
    },
    getters: {
        getPermissionList: state => state.permissionList,
        getPermissionError: state => state.error,
        getPermissionMsg: state => state.msg
    }
}

export default Permission;